import { Outlet, ScrollRestoration } from 'react-router-dom';
import { Box } from '@mui/material';

export default function Root() {
  return (
    <Box id="content">
      <Outlet />
      {/* New pages start at the top; Back restores the previous position */}
      <ScrollRestoration />
    </Box>
  );
}
